import React from 'react';

import { ErrorCallout, Text } from '../../components';
import { Card } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createCorrectMarketRestockStyles } from './CorrectMarketRestockView.styles';

// After a correction to an already confirmed count: asks whether the market's physical stock changed too.
const RestockCorrectionSaved = ({ savedCorrection }) => {
	const styles = useThemedStyles(createCorrectMarketRestockStyles);

	return (
		<>
			<Text style={styles.sectionTitle}>Delivered quantities corrected</Text>
			<Card>
				<Text style={styles.notice}>
					The corrected delivery is saved as revision {savedCorrection.revision}. The
					confirmed stock count and current live count were not changed by this delivery correction.
				</Text>
			</Card>
			<Text style={styles.followUpQuestion}>
				Did the products or quantities physically in the market also change?
			</Text>
			<Text style={styles.intro}>
				If the existing confirmed count is still correct, keep the delivery correction only. If
				the market contents changed, review the actual physical quantities before confirming stock
				again. Sentry will not infer physical stock from the corrected delivery.
			</Text>
			{!savedCorrection.availability?.allowed && (
				<ErrorCallout text={savedCorrection.availability?.reason || (
					'Stock cannot be safely reconfirmed from this service. Arrange a controlled stock review instead.'
				)} />
			)}
		</>
	);
};

export default RestockCorrectionSaved;
